import { JSX } from 'react';

import { SensorTypeEnum, SensorTypeEnumWithoutSection } from '@/types/sensor/sensors';

import { SensorOrSubSensorInfoByType, SensorOrSubSensorTypeEnum } from '../../monitoring.types';
import { HolopticsSections, maintenanceAndCommandSection } from './section/sensor';
import { AutomatonSections } from './section/sensor/automaton/AutomatonSection';
import { HolodroneSections } from './section/sensor/holodrone/HolodroneSections';
import { SectionViewer } from './SectionViewer';

export type SensorSectionFactory<T extends SensorTypeEnumWithoutSection> = (
  props: SensorOrSubSensorInfoByType<T>,
) => [JSX.Element | null, string | null];

export type SensorSection = [JSX.Element | null, string | null];

export type SensorsGlobalTabType = Partial<{
  [T in SensorOrSubSensorTypeEnum]: Map<
    string | ((value: SensorOrSubSensorInfoByType<T>) => string),
    SensorSectionFactory<T>
  >;
}>;

export const SensorsGlobalTab: SensorsGlobalTabType = {
  [SensorTypeEnum.AF2206]: HolopticsSections,
  [SensorTypeEnum.AXIS]: HolopticsSections,
  [SensorTypeEnum.HOLODRONE]: HolodroneSections,
  [SensorTypeEnum.AUTOMATON]: AutomatonSections,
};

export default function GlobalTab<T extends SensorOrSubSensorTypeEnum>({
  sensorOrSubSensorInfo,
}: Readonly<{ sensorOrSubSensorInfo: SensorOrSubSensorInfoByType<T> }>) {
  const sections: Map<
    string | ((value: SensorOrSubSensorInfoByType<T>) => string),
    SensorSectionFactory<T>
  > = SensorsGlobalTab[sensorOrSubSensorInfo.configuration.type as T] ?? new Map([maintenanceAndCommandSection]);

  const sectionsEntries = Array.from(sections.entries())
    .map(([key, sensorSection]): [string, SensorSection] => [
      typeof key === 'string' ? key : key(sensorOrSubSensorInfo),
      sensorSection(sensorOrSubSensorInfo),
    ])
    .filter(([, node]) => node[0] !== null);

  return <SectionViewer sections={sectionsEntries} sensorOrSubSensorInfo={sensorOrSubSensorInfo} />;
}
